import React from "react"
import { withDataComponents } from "higher-order-components"
import { VideoSlideshow } from "components"

const FullWidthMultiVideoBlock = props => (
  <VideoSlideshow {...props} />
)

// withDataComponent strips off the backend `name` and `props` structure and just exposes the props
export default withDataComponents({
  expectedComponent: "FullWidthVideoItemBlock",
  mapInputToOutput: [["items", "videos"]]
})(FullWidthMultiVideoBlock)



// WEBPACK FOOTER //
// ./src/blocks/full-width-multi-video/index.jsx